<template>
  <div class="bg-yellow-200 px-3 sm:px-16 md:px-24">
    <section class="flex pt-12 mb-20">
      <div class="flex-1 p-0 lg:pr-8">
        <Heading class="mb-6 sm:mb-10 text-center lg:text-left" size="extra">
          BuildaBox.co is...
        </Heading>
        <p class="mb-6 sm:mb-10 leading-7 sm:leading-8 text-center lg:text-left">
          BuildaBox.co is the go-to tool for Event and Meeting Producers, Marketing Professionals and others to help
          build hyper-personalized, data-driven, super-effective event and meeting programs. Beyond the technology,
          BuildaBox.co professionals provide support with planning, event and meeting program management, analytics and
          fulfillment.
        </p>
      </div>
      <div class="hidden lg:block lg:flex-1">
      </div>
      <div
          class="hidden lg:block w-1/2 bg-white absolute strange-thing bg-cover shadow-primary absolute top-0 right-0"></div>
    </section>
    <section>
      <Heading center class="mb-6 sm:mb-10" size="extra">
        BuildaBox.co works...
      </Heading>
      <p class="leading-7 sm:leading-8 mb-6 sm:mb-10 text-center lg:text-left">
        BuildaBox.co works because BuildaBox.co organizes and automates the most routine tasks of every meeting or
        event. For event and meeting planners, BuildaBox.co provides the tools to design an event, gather personalized
        info from attendees, automate messaging, and reduce or eliminate data entry tasks while organizing caterers,
        suppliers and team members.
      </p>
      <div class="leading-7 sm:leading-8 mb-6 sm:mb-10 text-center lg:text-left">
        Whether BuildaBox.co is being used in support of a global multi-event campaign or to support a streamlined
        new-hire onboarding program, it simply works.
      </div>
    </section>
    <hr class="border border-gray-400 border-t mt-12 mb-10 sm:mb-16 sm:mt-20 w-2/3 mx-auto "/>
    <section>
      <Heading center class="mb-6 sm:mb-10" size="extra">Here's How BuildaBox.co Works...</Heading>

      <div class="sm:flex sm:justify-center sm:flex-wrap">
        <div class="sm:min-w-20 sm:flex-1 m-4">
          <img
              alt="Design an Event"
              class="mx-auto mb-8 w-32 h-32"
              src="../assets/icons/landing-icon-1.png"
              srcset="../assets/icons/landing-icon-1.png, ../assets/icons/landing-icon-1@2x.png 1.5x, ../assets/icons/landing-icon-1@3x.png 2x"
          />
          <h1 class="text-lg text-center font-semibold mb-4">
            Design an Event
          </h1>
          <p class="text-left w-4/5 mx-auto">
            Start your BuildaBox.co experience by designing the template for your event. In this step you add event or
            program details, invite team members, build a menu, create survey questions, add automated messages, add
            digital content sharing resources, add attendee segmentation and invite your attendees.
          </p>

        </div>
        <div class="sm:min-w-20 sm:flex-1 m-4 py-4 sm:py-0">
          <img
              alt="Attendees & Collaborators Get to Work"
              class="mx-auto mb-8 w-32 h-32"
              src="../assets/icons/landing-icon-2.png"
              srcset="../assets/icons/landing-icon-2.png, ../assets/icons/landing-icon-2@2x.png 1.5x, ../assets/icons/landing-icon-2@3x.png 2x"
          />
          <h1 class="text-lg text-center font-semibold mb-4">
            Attendees & Collaborators Get to Work
          </h1>
          <p class="text-left w-4/5 mx-auto">
            After the BuildaBox.co event or program is designed and attendees are invited, they complete personalized
            order forms and 'build their box.'
            <br><br>
            Event planners manage the entire process by adding and removing attendees and collaborators, making updates
            and tracking progress. The automated, segmented, messaging makes it easy to keep groups of attendees and
            collaborators informed.
          </p>
        </div>
        <div class="sm:min-w-20 sm:flex-1 m-4">
          <img
              alt="Execute & Reuse the Event Template"
              class="mx-auto mb-8 w-32 h-32"
              src="../assets/icons/landing-icon-1.png"
              srcset="../assets/icons/landing-icon-3.png, ../assets/icons/landing-icon-3@2x.png 1.5x, ../assets/icons/landing-icon-3@3x.png 2x"
          />
          <h1 class="text-lg text-center font-semibold mb-4">
            Execute & Reuse the Event Template
          </h1>
          <p class="text-left w-4/5 mx-auto">
            BuildaBox.co supports one time events, multi-event campaigns and ongoing programs. Once you have a template
            for a single event, leverage the flexible management tools, CRM integrations, digital content sharing
            portals and the BuildaBox.co Catering and Kitting Support Services, to build incredibly effective event,
            meeting, marketing, onboarding and training programs.
          </p>
        </div>
      </div>

      <div class="lg:px-24 mt-12">
        <div class="sm:flex sm:justify-center">
          <router-link to="/get-in-touch">
            <button class="btn btn-primary font-semibold rounded-lg w-full sm:w-56 sm:mr-12 mb-4 sm:mb-0">
              Get In Touch Now
            </button>
          </router-link>
          <router-link :to="{name: 'segmentation-wizard'}">
            <button class="btn btn-primary font-semibold rounded-lg w-full sm:w-56 sm:ml-12">
              Build Your Box
            </button>
          </router-link>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Heading from '@/components/common/Heading'

export default {
  name: 'HowItWorks',
  data () {
    return {
      loading: false,
      address: ''
    }
  },
  components: { Heading }
}
</script>

<style scoped>
.strange-thing {
  background-image: url('../assets/images/landing-img.png');
  background-size: cover;
  height: 29rem;
  top: 95px;
  border-bottom-left-radius: 100px;
}
</style>
